<template>
  <div>
    <transition mode="out-in">
      <section key="show" class="contacts-container" v-if="entries && entries.length > 0">
        <div class="contact" v-for="(entry, index) in entries" :key="index">
          <div class="name-address">
            <div class="name">
              <strong>{{ entry.name }}</strong>
              <h4 v-if="entry.employer_name">{{ entry.employer_name }}</h4>
              <h4 v-if="entry.partner_name">{{ entry.partner_name }}</h4>
            </div>
            <div class="extra-info">
              <p>
                <span v-if="entry.status !== 'Active'" class="inactive">Inactive</span>
              </p>
              <p class="program">
                <span>{{ entry.program }}</span>
              </p>
              <p>
                <span>{{ entry.role }}</span>
              </p>
              <p>
                <span v-if="entry.city">{{ entry.city }}</span>
                <span
                  v-if="(entry.country === 'United States' || entry.country === 'United States of America') && (entry.state || entry.stateCode)"
                >{{ entry.stateCode || entry.state }}</span>
                <span v-if="entry.country">{{ entry.country }}</span>
              </p>
            </div>
            <div class="phone" v-if="entry.phone && entry.phone.length > 3">
              <a :href="`tel:${entry.phone}`">
                <font-awesome-icon icon="phone" />
                {{ entry.phone | formatPhone(entry.country) }}
              </a>
            </div>
            <div class="email" v-if="entry.email">
              <a :href="`mailto:${entry.email}`">
                <font-awesome-icon icon="envelope" />
                {{ entry.email }}
              </a>
            </div>
          </div>
          <div class="contact-info">
            <a :href="`tel:${entry.phone}`" v-if="entry.phone">
              <button class="btn call">
                <font-awesome-icon icon="phone" />
              </button>
            </a>
            <a :href="`mailto:${entry.email}`" v-if="entry.email">
              <button class="btn mail">
                <font-awesome-icon icon="envelope" />
              </button>
            </a>
            <router-link :to="{ name: 'profile', params: { id: entry.id } }">
              <button class="btn search">
                <font-awesome-icon icon="search-plus" />
              </button>
            </router-link>
          </div>
        </div>
        <section class="pagination">
          <DirectoryPagination :totalOfEntries="totalOfEntries" :entriesPerPage="entriesPerPage" />
        </section>
      </section>

      <section
        key="noEntries"
        class="contacts-container"
        v-else-if="entries && entries.length === 0"
      >
        <div class="no-results">
          <p>No results found for your search and filters.</p>
        </div>
      </section>

      <section key="loading" v-else>
        <PageLoading />
      </section>
    </transition>
  </div>
</template>

<script>
import DirectoryPagination from "@/components/DirectoryPagination.vue";
import { api } from "@/services.js";
import { serialize } from "@/helpers.js";

export default {
  name: "DirectoryData",
  components: {
    DirectoryPagination
  },
  data() {
    return {
      entries: null,
      totalOfEntries: 0,
      entriesPerPage: 20
    };
  },
  computed: {
    url() {
      const query = serialize(this.$route.query);
      return `/directory?_limit=${this.entriesPerPage}${query}`;
    },
    q() {
      return this.$route.query.q;
    }
  },
  methods: {
    pullData() {
      this.entries = null;
      this.totalOfEntries = 0;
      api.get(this.url).then(r => {
        this.totalOfEntries = Number(r.data.total);
        this.entries = r.data.entries;
      });
    }
  },
  watch: {
    url() {
      this.entries = null;
      this.pullData();
    }
  },
  created() {
    this.entries = null;
    this.pullData();
  }
};
</script>

<style scoped>
.contact {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  padding: 15px 30px;
  border-bottom: 1px solid rgba(30, 60, 90, 0.1);
  position: relative;
}

.contact .inactive {
  color: #fff;
  background: rgba(214, 18, 18, 0.3);
}

.contact:nth-child(even) {
  background: rgba(0, 0, 0, 0.01);
}

.contact:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.contact:first-child {
  border-top: none;
}

.contact-info {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.contact-info button {
  padding: 11px 15px;
  margin-left: 15px;
  box-shadow: none;
  border-radius: 50%;
}

.contact-info button.call {
  background: rgb(104, 199, 104);
}

.contact-info button.mail {
  background: rgb(192, 64, 64);
}

.contact-info button.search {
  background: rgb(119, 179, 199);
}

.contact-info a {
  color: #fff;
}

.name-address {
  flex: 2;
}

.extra-info,
.name {
  display: flex;
  font-size: 1.2rem;
  text-transform: capitalize;
  margin-bottom: 3px;
}

.extra-info span {
  color: rgba(0, 0, 0, 0.9);
  font-size: 0.7rem;
  vertical-align: middle;
  margin-right: 5px;
  text-transform: uppercase;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: #f8f8f8;
  padding: 1px 4px;
  border-radius: 4px;
}

.name h4 {
  font-size: 0.9rem;
  font-weight: normal;
  margin: 5px;
}

.no-results {
  padding: 15px 20px;
}

.no-results p {
  color: #a83434;
  font-weight: 600;
}

@media only screen and (max-width: 767px) {
  .contact {
    display: flex;
    flex-direction: column;
    padding: 15px 5px;
  }

  .contact-info {
    justify-content: center;
    margin-top: 15px;
  }

  .extra-info {
    margin-bottom: 10px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .name-address {
    text-align: center;
    font-size: 0.9rem;
  }

  .name {
    display: flex;
    flex-direction: column;
  }
}
</style>
